import { render, staticRenderFns } from "./ViewProposalPdf.vue?vue&type=template&id=58a76afa&scoped=true"
import script from "./ViewProposalPdf.vue?vue&type=script&lang=js"
export * from "./ViewProposalPdf.vue?vue&type=script&lang=js"
import style0 from "./ViewProposalPdf.vue?vue&type=style&index=0&id=58a76afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a76afa",
  null
  
)

/* custom blocks */
import block0 from "./ViewProposalPdf.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports